import {memo, forwardRef} from 'react';
import type {ImgHTMLAttributes, Ref} from 'react';

import {useImage} from './use-image';

type Props = Omit<ImgHTMLAttributes<HTMLImageElement>, 'placeholder' | 'onLoad' | 'onError'> & {
    placeholder?: JSX.Element;
    fallback?: JSX.Element;
};

export const Image = memo(
    forwardRef(({placeholder, alt, fallback, src, ...rest}: Props, ref: Ref<HTMLImageElement>) => {
        const {isError, isLoaded} = useImage(src);

        if (isError && fallback) {
            return fallback;
        }

        return (
            <>
                {!isLoaded && placeholder}
                {isLoaded && <img src={src} ref={ref} alt={alt} {...rest} />}
            </>
        );
    }),
);

Image.displayName = 'Image';
